// extracted by mini-css-extract-plugin
module.exports = {"Main":"MarketplaceProductPage_Main__oLoqt"};